import "./ButtonIcon.scss";
import PropTypes from "prop-types";
import classNames from "classnames";

const BUTTON_ICON_SIZES = {
	NORMAL: "normal",
};

const ButtonIcon = props => {
	const { size = BUTTON_ICON_SIZES.NORMAL, onClick, className, children } = props;

	const buttonClasses = classNames("button-icon", size, className);

	return (
		<div onClick={onClick} className={buttonClasses}>
			{children}
		</div>
	);
};

ButtonIcon.propTypes = {
	size: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.any,
};

export default ButtonIcon;
export { BUTTON_ICON_SIZES };
